// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KpnZ","top":"styles_top__3nad6"};